export const getRecaptchaSiteKey = (): string => {
    let key = '';
    const dev = '6LdZBSkrAAAAAOisfjgoJg5ISoNtalO6B3KRDgvj';
    const qa = '6LeeXikrAAAAAHMFhxRV_MtXvaWKVR8msTdZQl9N';
    const stg = '6LcfLzYrAAAAAEXXSx8cvG437F4ndb4KcPz4zmzh';
    const prd = '6LeMQDYrAAAAAPB91MSWBg3waTwPmD622ZiwZTjh';
    const url = document.location.host;

    if (url.indexOf('localhost') > -1) {
        return key;
    }

    if (url.indexOf('devaka') > -1) {
        key = dev;
    }
    else if (url.indexOf('qaaka') > -1) {
        key = qa;
    }
    else if (url.indexOf('stgaka') > -1) {
        key = stg;
    } else {
        key = prd;
    }
    return key;
};
